import * as React from "react";
import { cn } from "../lib/utils.ts";

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("animate-pulse rounded-md bg-[var(--color-muted)]", className)} {...props} />
  );
}
